import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faSquareDollar } from '@fortawesome/pro-light-svg-icons/faSquareDollar';
import { faSquareList } from '@fortawesome/pro-light-svg-icons/faSquareList';
import { faSquarePlus } from '@fortawesome/pro-light-svg-icons/faSquarePlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useWizardContext } from 'src/modules/modules/hooks/useWizardContext';
function getHeaderOptions({ extra, isUpdate, paidModule, isFirstStep }) {
    if (!isUpdate && isFirstStep) {
        return { title: 'modules.new_module' };
    }
    const label = isUpdate ? 'edit' : 'create';
    const flowTitles = {
        main: { title: `modules.flow_title.main.${label}`, icon: faSquareList },
        additional: { title: `modules.flow_title.additional.${label}`, icon: faSquarePlus },
        additionalPaid: { title: `modules.flow_title.additional_paid.${label}`, icon: faSquareDollar }
    };
    const key = extra ? (paidModule ? 'additionalPaid' : 'additional') : 'main';
    return flowTitles[key];
}
export function Header({ extra, paidModule, isUpdate }) {
    const { t } = useTranslation();
    const { isFirstStep } = useWizardContext();
    const headerOptions = getHeaderOptions({ extra, paidModule, isFirstStep, isUpdate });
    return (_jsxs("div", { className: "flex h-7 items-center gap-4", children: [headerOptions?.icon && (_jsx("div", { className: "h-6 w-6 rounded-medium bg-neutral-100 p-2", children: _jsx(FontAwesomeIcon, { icon: headerOptions.icon, className: "h-4 w-4 text-neutral-500" }) })), _jsx("h1", { className: "text-medium text-neutral-900", children: t(headerOptions.title) })] }));
}
